import Vue from 'vue'
import VueScrollTo from 'vue-scrollto'
import VueTelInput from 'vue-tel-input'
import Datetime from 'vue-datetime'
import { DateTime } from 'luxon'
import {i18n} from './translations/i18n'
import { resolveJSON } from '@/helperfunctions'
import App from './App.vue'
import router from './router'
import 'vue-datetime/dist/vue-datetime.css'

Vue.config.productionTip = false

Vue.use(VueScrollTo)
Vue.use(VueTelInput)
Vue.use(Datetime)

new Vue({
  data: {
    mep: {},
    phonenumber: {
      formatted: null,
      digit: null,
    },
    country: '',
    countries: [['de', 'Germany']],
    fetchingCountries: false,
    recurringPicker: {
      weekday: {
        Monday: false,
        Tuesday: false,
        Wednesday: false,
        Thursday: false,
        Friday: false,
      },
      deactivated: true,
      time: DateTime.local(1970, 1, 1, 13, 0).toString(),
    },
    callInitiated: false,
    loadingAnimation: false,
    officeClosed: false,
  },
  watch: {
    'phonenumber.formatted': 'unformatPhonenumber',
  },
  created () {
    this.getCountryFromIP()
    this.setPickerTime()
  },
  methods: {
    unformatPhonenumber () {
      this.phonenumber.digit = this.phonenumber.formatted.replace(/[() \-/]/g, '')
    },
    getCountryFromIP () {
      fetch('/api/country')
        .then(resolveJSON)
        .then(json => {
          this.country = json.country
        })
        .catch(error => {
          console.error(error)
          this.country = 'de'
        })
    },
    setPickerTime () {
      if (!this.officeClosed) {
        const now = DateTime.local().toUTC()
        const setHour = Number(now.toLocal().toFormat('H'))
        const setMinute = 5 * Math.floor(now.toLocal().toFormat('m') / 5)
        return DateTime.local(1970, 1, 1, setHour, setMinute).toString()
      }
    },
  },
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
